module.exports = {
    "File Upload": "File Upload",
    Image: "Image",
    Video: "Video",
    Audio: "Audio",
    WorkSheet: "WorkSheet"
};
